import { AxiosResponse } from 'axios';

import { axiosClient } from '../config/axios-client';
import { GameType } from '../model/enumeration/GameType.enum';
import { WaitlistPlayerResponse } from '../model/WaitlistPlayerResponse';

class WaitListStore {
  public getWaitListPlayers = (
    tableId: string,
  ): Promise<WaitlistPlayerResponse[]> =>
    axiosClient
      .get<WaitlistPlayerResponse[]>(this.getBaseApiPath(tableId))
      .then(response => response.data);

  public addBotToWaitList = (
    tableId: string,
    gameType: GameType,
    pid: string,
    buyIn: number,
  ): Promise<AxiosResponse<void>> =>
    axiosClient.post(`${this.getBaseApiPath(tableId)}/${pid}`, {
      gameType,
      buyIn,
    });

  public removeBotFromWaitList = (
    tableId: string,
    gameType: GameType,
    pid: string,
  ): Promise<AxiosResponse<void>> =>
    axiosClient.post(`${this.getBaseApiPath(tableId)}/${pid}/remove`, {
      gameType,
    });

  private getBaseApiPath = (tableId: string): string => `/waitlist/${tableId}`;
}

const waitListStore = new WaitListStore();
export default waitListStore;
